import {
  GET_FOOD_LOG_RANGE,
  GET_FOOD_LOG_RANGE_SUCCESS,
  GET_FOOD_LOG_RANGE_ERROR,
} from './constants';

/**
 * Fetch the user's food logs between two YYYY-MM-DD dates (inclusive).
 * `from` and `to` are required by the API but optional here — the saga
 * passes them through as query params.
 */
export function getFoodLogRange(from, to) {
  return { type: GET_FOOD_LOG_RANGE, from, to };
}

export function getFoodLogRangeSuccess(payload) {
  return { type: GET_FOOD_LOG_RANGE_SUCCESS, payload };
}

export function getFoodLogRangeError(err) {
  return { type: GET_FOOD_LOG_RANGE_ERROR, err };
}
